// Cobros and Pagos load every shift of the period on the server, so both screens
// stop at three months, as the server does (FinancePeriodParams::MAX_PERIOD_DAYS):
// 93 days counting both ends, so any three calendar months fit.
export const FINANCE_MAX_PERIOD = { days: 93, label: '3 meses' } as const;
